"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var config_1 = require("../../config");

var Icon_1 = __importStar(require("../../Icon"));

var Burger =
/** @class */
function (_super) {
  __extends(Burger, _super);

  function Burger() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      open: false
    };

    _this.toggle = function () {
      _this.setState({
        open: !_this.state.open
      });
    };

    return _this;
  }

  Burger.prototype.componentDidUpdate = function (prevProps, prevState) {
    if (this.state.open !== prevState.open) {
      if (this.state.open) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    }
  };

  Burger.prototype.render = function () {
    var className = this.props.className;
    var b = config_1.block('burger');
    return react_1.default.createElement("a", {
      href: "javascript:void(0);",
      className: b({}).mix(className),
      onClick: this.toggle
    }, react_1.default.createElement(Icon_1.default, {
      icon: this.state.open ? Icon_1.IconType.Cross : Icon_1.IconType.Burger,
      width: 24,
      height: 24
    }));
  };

  return Burger;
}(react_1.default.Component);

exports.default = Burger;